var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$store.state.isLogged)?_c('Header',{staticClass:"header-bg"}):_vm._e(),(_vm.$store.state.navMenu)?_c('Menu'):_vm._e(),_c('Content'),(_vm.$store.state.isLogged)?_c('Fotter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }